import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inviteBulkGrid" }
const _hoisted_2 = {
  ref: "gridScroll",
  class: "gridScroll"
}
const _hoisted_3 = { class: "gridTable" }
const _hoisted_4 = {
  key: 0,
  class: "rowStatusCol"
}
const _hoisted_5 = { class: "rowNumCol" }
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = ["checked", "disabled", "onChange"]
const _hoisted_8 = {
  key: 2,
  class: "cellText"
}
const _hoisted_9 = ["value", "onChange"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 1,
  class: "cellText"
}
const _hoisted_12 = ["type", "inputmode", "value", "onBlur", "onKeydown"]
const _hoisted_13 = {
  key: 5,
  class: "cellText"
}
const _hoisted_14 = { class: "actionsCol" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneNumberInput = _resolveComponent("PhoneNumberInput")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "rowNumCol" }, "#", -1)),
            (_ctx.hasStatusColumn)
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Status"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (col) => {
              return (_openBlock(), _createElementBlock("th", {
                key: col.key,
                class: _normalizeClass({ requiredCol: col.required })
              }, _toDisplayString(col.label), 3))
            }), 128)),
            _cache[7] || (_cache[7] = _createElementVNode("th", {
              class: "actionsCol",
              "aria-label": "Delete row"
            }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: rowIndex,
              class: _normalizeClass({ 'row-locked': _ctx.isLocked(rowIndex) })
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(rowIndex + 1), 1),
              (_ctx.hasStatusColumn)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: _normalizeClass(["rowStatusCell", { 'rowStatusFailed': _ctx.rowErrors[rowIndex] != null }])
                  }, _toDisplayString(_ctx.rowErrors[rowIndex] ?? _ctx.rowStatuses[rowIndex]), 3))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (col) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: col.key,
                  class: _normalizeClass(_ctx.cellClass(rowIndex, col)),
                  title: _ctx.cellErrorMessage(rowIndex, col),
                  onClick: ($event: any) => (_ctx.beginEdit(rowIndex, col))
                }, [
                  (col.type === 'bool')
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "checkbox",
                        checked: row[col.key] === true,
                        disabled: _ctx.isLocked(rowIndex),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        onChange: ($event: any) => (_ctx.onBoolChange(rowIndex, col, $event))
                      }, null, 40, _hoisted_7))
                    : (col.key === 'phone' && _ctx.isEditing(rowIndex, col))
                      ? (_openBlock(), _createBlock(_component_PhoneNumberInput, {
                          key: 1,
                          class: "cellPhone",
                          inputId: 'cellPhone_' + rowIndex,
                          countrySelectId: 'cellPhoneCountry_' + rowIndex,
                          phoneNumberLabel: ' ',
                          noMatchingCountriesLabel: 'No matching countries.',
                          phoneCountryCodes: _ctx.phoneCountryCodes,
                          phoneCountryCode: _ctx.editingPhoneCountry,
                          phoneNumber: _ctx.stringValue(row.phone),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                          onUpdatePhoneNumber: ($event: any) => (_ctx.onPhoneNumberUpdate(rowIndex, $event)),
                          onUpdatePhoneCountryCode: ($event: any) => (_ctx.onPhoneCountryUpdate(rowIndex, $event))
                        }, null, 8, ["inputId", "countrySelectId", "phoneCountryCodes", "phoneCountryCode", "phoneNumber", "onUpdatePhoneNumber", "onUpdatePhoneCountryCode"]))
                      : (col.key === 'phone')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.phoneDisplay(row)), 1))
                        : (col.type === 'select')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_ctx.isEditing(rowIndex, col))
                                ? (_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: "cellInput cellSelect",
                                    style: _normalizeStyle(_ctx.editInputStyle(_ctx.displaySelectValue(row[col.key], col))),
                                    value: _ctx.stringValue(row[col.key]),
                                    onChange: ($event: any) => (_ctx.commitSelect(rowIndex, col, $event)),
                                    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)), ["esc"]))
                                  }, [
                                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions(col), (opt) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: opt.value,
                                        value: opt.value
                                      }, _toDisplayString(opt.label), 9, _hoisted_10))
                                    }), 128))
                                  ], 44, _hoisted_9))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.displaySelectValue(row[col.key], col)), 1))
                            ], 64))
                          : (_ctx.isEditing(rowIndex, col))
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 4,
                                class: "cellInput",
                                type: col.type === 'date' ? 'date' : 'text',
                                inputmode: col.type === 'number' ? 'numeric' : undefined,
                                style: _normalizeStyle(_ctx.editInputStyle(_ctx.editingDraft)),
                                value: _ctx.editingDraft,
                                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDraftInput && _ctx.onDraftInput(...args))),
                                onBlur: ($event: any) => (_ctx.commitEdit(rowIndex, col, $event)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.commitEdit(rowIndex, col, $event)), ["prevent"]), ["enter"]),
                                  _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)), ["esc"]))
                                ]
                              }, null, 44, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.displayValue(row[col.key])), 1))
                ], 10, _hoisted_6))
              }), 128)),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "deleteRowBtn",
                  title: "Delete row",
                  "aria-label": "Delete row",
                  onClick: ($event: any) => (_ctx.$emit('delete-row', rowIndex))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                ], 8, _hoisted_15)
              ])
            ], 2))
          }), 128)),
          (_ctx.rows.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                _createElementVNode("td", {
                  colspan: _ctx.columnCount,
                  class: "emptyRow"
                }, " No rows yet. Upload a CSV or add an invite to begin. ", 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512)
  ]))
}